import{ FormGroup, Input, Label, FormFeedback } from "reactstrap";
import { useSelector } from "react-redux";
import isEmpty from "../../../../validation/is-empty";
import { isSmsAllowed } from "../../../../utils/trialAccess";

const SMSReminder = ({data, handleChange}) => {
    const userPlan = useSelector((state) => state.subscription?.userPlan);
    const featureAccess = useSelector((state) => state.featureAccess);
    const smsUnlocked = isSmsAllowed(userPlan, featureAccess);
    
    const addReminder = () => {
        const sms_reminders = data.sms_reminders ? [...data.sms_reminders] : [];
        sms_reminders.push({duration: "", customized: '', isInvalid: false});
        handleChange({
            target: {
                name: "sms_reminders",
                value: sms_reminders,
            }
        });
    }

    /**
   * remove reminder
   */
    const removeReminder = (index) => {
        data?.sms_reminders.splice(index, 1);
        handleChange({
            target: {
                name: "sms_reminders",
                value: data?.sms_reminders,
            },
        });
    };

    /**
     * update duration
     * @param {*} e 
     */
    const updateDuration = (e, index) => {
        data.sms_reminders[index].duration = e.target.value;
        handleChange({
            target: {
                name: "sms_reminders",
                value: data?.sms_reminders
            },
        });
    }

    const handleInvalid = (index) => {
        const updated = [...data.sms_reminders];
        updated[index].isInvalid = true;
        handleChange({
            target: {
                name: "sms_reminders",
                value: updated
            },
        });
        console.log('handleInvlid update', updated);
    };


    const handleInput = (index) => {
        const updated = [...data.sms_reminders];
        updated[index].isInvalid = false;
        handleChange({
            target: {
                name: "sms_reminders",
                value: updated
            },
        });
        console.log('handleInput update', updated);
    };

    console.log('rendered');

    return (
        <div className="time-status">
            {/* <div className="tittle mb-3">
                <h2>Timming (SMS Reminder)</h2>
            </div> */}
            <div className="status-toggle">
                <h2>SMS Reminder</h2>
                <div className="toggle_fields">
                    <div className="toggle_field">
                        <div className="box_content p-0">
                            <div className="form-check form-switch">
                                <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexSwitchCheckChecked18"
                                checked={
                                    smsUnlocked && data.sms_reminder_status === "E"
                                }
                                disabled={!smsUnlocked}
                                onChange={(event) => {
                                    handleChange({
                                        target: {
                                            name: "sms_reminder_status",
                                            value: event.target.checked ? "E" : "D",
                                        },
                                    });
                                }}
                                />
                                <label
                                className="form-check-label cus_label"
                                htmlFor="flexSwitchCheckChecked18"
                                >
                                {smsUnlocked ? "On" : "Available after you subscribe"}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {smsUnlocked && data.sms_reminder_status === "E" && (
                <>
                    {(data.sms_reminders || []).map((reminder, index) => {
                        return (
                            <div className="select-timing" key={`sms-reminder-${index}`}>
                                <FormGroup>
                                    <Input 
                                        name="sms-reminders" 
                                        type="select" 
                                        value={reminder.duration}
                                        onChange={(e) => {
                                            updateDuration(e, index);
                                        }}
                                    >
                                        <option value="">Minute(s)</option>
                                        <option value="15">15</option>
                                        <option value="30">30</option>
                                        <option value="45">45</option>
                                        <option value="60">60</option>
                                        <option value="custom">Custom</option>
                                    </Input>
                                </FormGroup>
                                {reminder.duration == 'custom' && (
                                    <>
                                        <Input
                                            min={15}
                                            max={240} 
                                            type="number"
                                            className="form-control mb-3" 
                                            placeholder="15"
                                            value={ 
                                                !isEmpty(data.sms_reminders[index].customized) ? 
                                                    data.sms_reminders[index].customized : 
                                                    '' 
                                            }
                                            onChange={(e) => {
                                                data.sms_reminders[index].customized = e.target.value;
                                                handleChange({
                                                    target: {
                                                        name: "sms_reminders",
                                                        value: data?.sms_reminders
                                                    },
                                                });
                                            }}
                                            onInvalid={() => handleInvalid(index)}
                                            onInput={() => handleInput(index)}
                                            invalid={reminder.isInvalid}
                                        />
                                        <FormFeedback className="col-md-3">Please enter a number between 15 and 240</FormFeedback>
                                    </>
                                )}

                                <button
                                    type="button"
                                    className="rd_hourlyavalmodalitemblock1del"
                                    onClick={() => {
                                        removeReminder(index);
                                    }}
                                ></button>

                                <p>Before event</p>
                            </div>
                        )
                    })}

                    {(data.sms_reminders || []).length < 5 && (
                        <div className="add-reminder mb-3 mt-2" style={{fontSize:'1.2rem'}}>
                            <button type="button" className="add-remider-btn" onClick={() => { addReminder() }}>
                                + Add another reminder
                            </button>
                        </div>    
                    )}
                    
                    {/* <div className="sms-box">
                        <FormGroup>
                        <Label for="exampleText">
                            Text Messages
                        </Label>
                        <Input
                            id="exampleText"
                            name="text"
                            type="textarea"
                            placeholder="Reminder:Event Name with MyName at Event Time on Event Date"
                        />
                        </FormGroup>
                    </div> */}
                </>
            )}
        </div>
    );
}

export default SMSReminder;